import React from 'react'
import { Spin,Tooltip,message } from 'antd';
import ModalFormComponent from '@components/ModalForm/ModalForm';
import AuthBtn from "@components/HoverIcon/AuthBtn";
import AutoFetchTable from "@/components/AutoFetchTable/AutoFetchTable";
import Lang from "@components/Lang/Lang";
import dayjs from 'dayjs';
import {postWaitIntoWarehouseList, postInserIntoWarehouse} from '@/api/warehouseManagement/registration'
import LogisticsAndCabinetSwitch from "@/components/Logistics/LogisticsAndCabinetSwitch";
import { toFixedWithCommas} from "@utils/number-util";
import eventProxy from '@/utils/eventProxy';
import PageCommon from  "@components/PageCommon/PageCommon";
/**
 * 待入库 页签 | 使用统一的 查询表格组件
 *
 * @author FJJ
 * @version 2.0
 *
 * History:
 * Date      Version Remarks
 * ========= ======= ======================================================
 * 2022      1.0     First version Zhaoruji  => 备份在 WaitWarehouse.bak.js
 *
 * @copyright 2021-2021, all rights reserved. Essa.cn
 * */
export default class WaitWarehouseTable extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            isModalVisible: false,
            loading: false,
            list: [],
            // 表单 配置
            searchFormOptions:[
                {
                    name:'transitCityIds',
                    cnTitle:'',
                    cnTitleId:'',
                    cnPlaceholder:'所有仓库',
                    cnPlaceholderId:'SuoYouCangKu',
                    type:'WarehouseSelect',
                },
                {
                    name:'keyWord',
                    cnTitle:'',
                    cnTitleId:'',
                    cnPlaceholder:'请输入集柜单号或柜号',
                    cnPlaceholderId:'QingShuRuJiGuiDanHaoHuoGuiHao',
                    // type:'SearchInput',
                    width:256,
                },
            ],
            columns:[
                {
                    cnTitle: '集柜单号',
                    dataIndex: 'code',
                    cnTitleId: 'JiGuiDanHao',
                    render:(code, record, index) => (<>
                        <p className={"black89 font-bold"}>{code}</p>
                        {code&&<div>
                            <LogisticsAndCabinetSwitch showContainerCode = {false}
                                                       poId = {record.poId}
                                                       showPoOutInfo={false}
                                                       poCode={record.poCode}
                                                       containerCode={record.code}
                                                       cabinetNum={record.cabinetNum}
                                                       logisticsData={record.pubOrderTrackVOS}  />
                        </div>}
                    </>)
                },
                {
                    cnTitle: '订单数',
                    dataIndex: 'orderNumCount',
                    cnTitleId: 'DingDanShu',
                },
                {
                    cnTitle: '商品信息',
                    dataIndex: 'poCreateTime',
                    cnTitleId: 'ShangPinXinXi',
                    render:  (text, record, index) => (
                        <span>{record.skuNum}{Lang({id:'Kuan', default:'款'})}, {record.quantity}{Lang({id: 'Xiang', default: '箱'})}</span>
                    )
                },
                {
                    cnTitle: '总体积m³',
                    dataIndex: 'volume',
                    cnTitleId: 'ZongTiJiM3',
                    render: (totalVolume, record) => <span className="content-text">{toFixedWithCommas(totalVolume, 3) || "-"}</span> //{" "}m³
                },
                {
                    cnTitle: '目的仓库',
                    cnTitleId: 'MuDiCangKu',
                    dataIndex: 'transitCityName',
                },
                {
                    cnTitle: '时间',
                    cnTitleId: 'ShiJian',
                    dataIndex: 'time',
                    render:(text, record, index) => (<>
                        <p>
                            <Tooltip placement="left" title={Lang({id: 'ZhuangGuiFaYunShiJian', default: '装柜发运时间'})}>
                                <i className="ri-truck-line mr_6 black33"></i>{record.loadDate ? dayjs(record.loadDate).format('YYYY-MM-DD') : '-'}
                            </Tooltip>
                        </p>
                        <p>
                            <Tooltip placement="left" title={Lang({id: 'YuJiDaoGangShiJian', default: '预计到达时间'})}>
                                <i className="ri-map-pin-line mr_6 color-green"></i>{record.preArrivalPortDate?dayjs(record.preArrivalPortDate).format('YYYY-MM-DD'):'-'}
                            </Tooltip>
                        </p>
                   </> )
                },
                {
                    cnTitle: '操作',
                    dataIndex: 'CaoZuo',
                    width: 100,
                    cnTitleId: 'CaoZuo',
                    render: (item = {}, record) => (<div >
                        <AuthBtn icon={"ri-calendar-check-line"} tips = {Lang({id:"QueRenRuKu",default:"确认入库"})}
                                       onClick={()=>this.openModal(true,record)}/>
                    </div>)},
            ],
        }
        this.intoWarehouseInfo = {}
    }
    openModal(flag=true,row={}) {
        this.intoWarehouseInfo = row
        this.setState({
            isModalVisible: flag,
        })
    }
    loading(flag){
        this.setState({
            loading: flag
        })
    }
    // 提交完成
   async formOnFinish(value) {
       value.intoWarehouseTime = dayjs(value.intoWarehouseTime).valueOf().toString();
       value.id = this.intoWarehouseInfo.id;
       this.loading(true)
        postInserIntoWarehouse(value).then(res => {
            this.loading(false)
            if (res.data.success && res.data.valid) {
                message.success(Lang({id: 'CaoZuoChengGong', default: '操作成功'}))
                eventProxy.emit('getMenusRedPoint')
                this.setState({isModalVisible: false}, () => {
                    this.onPageTemplateTableChild.handleFetch(1,{},true)
                })
            } else {
                message.info(res.data.message);
            }
        })
    }
    disabledDate(current) {
        return  current && current < dayjs(this.intoWarehouseInfo.loadDate).endOf('day');
    }
    fetchBack(data={}){    // 查询回调
        this.onRefPageCommonChild.isShowTop()
        const {success,valid,model={} } = data;
        if(success&&valid&&model){
            // this.props.changeWaitIntoNum && this.props.changeWaitIntoNum(paging.total)
            this.props.changeNum && this.props.changeNum(model.waitIntoWarehouseCount||0,model.waitIntoNum||0)
        }
    }
    onRefForm = (ref) =>  this.onRefFormFormat = ref;
    onRefTabOne = (ref) =>  this.onPageTemplateTableChild = ref;
    onRefPageCommon = (ref) => this.onRefPageCommonChild = ref;
    render() {
        const {loading, columns,searchFormOptions,isModalVisible } = this.state;
        return (<PageCommon onRef={this.onRefPageCommon}>
                <Spin spinning={loading}>
                    <AutoFetchTable columns={columns}
                                    onRef={this.onRefTabOne}
                                    flagShowReset={false}
                                    // flagShowSearchBtn={false}
                                    fetchCallBack={(data)=>this.fetchBack(data)}
                                    pageSize={50}
                                    searchFormOptions={searchFormOptions}
                                    fetchApi={'/service/mg/warehouse-management/wait-into-warehouse-list'} />
                </Spin>

                {isModalVisible&&<ModalFormComponent showModal={isModalVisible}
                                                     onRef={this.onRefForm}
                                                     loading={loading}
                                                     title={{cnTitleId: 'QueRenRuKu',cnTitle:'确认入库'}}
                                                     options={[
                                                         {
                                                             name:'intoWarehouseTime',
                                                             cnTitle:'入库时间',
                                                             cnTitleId:'RuKuShiJian',
                                                             cnPlaceholder:'请选择日期',
                                                             cnPlaceholderId:'QingXuanZeRiQi',
                                                             disabledDate: this.disabledDate.bind(this),
                                                             // disabledLessThanBeforeToday:this.intoWarehouseInfo.loadDate,
                                                             type:'Date',
                                                             required: true,
                                                         },
                                                         {
                                                             name:'customsClearanceNo',
                                                             cnTitle:'清关单单号',
                                                             cnTitleId:'QingGuanDanDanHao',
                                                             cnPlaceholder:'请输入',
                                                             cnPlaceholderId:'QingShuRu',
                                                             required: true,
                                                         }
                                                     ]}
                                                     saveFormValue={(data)=>this.formOnFinish(data)}
                                                     handleCancel={()=>this.openModal(false)}
                />}
            </PageCommon>
        )
    }
}